

import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Productcard from "../../components/ReTask/index";
import PendingTasks from "../../components/ReTask/PendingTasks";
import { Button, Typography, CircularProgress } from "@mui/material";
import Plus from "../../../src/assests/images/Plus.svg";
import Notask from "../../components/ReTask/Notask";
import notask from "../../../src/assests/images/no-task.svg";
import { useNavigate, useParams } from "react-router-dom";
import ActiveTask from "../../components/ActiveTask/ActiveTask";
import CompletedTask from "../../components/ActiveTask/CompletedTask";
import { useState, useEffect } from "react";
import { getToken } from "../../utils/utils";
import { Activetasktab, ispubishedchnages } from "../../components/ActiveTask/api";
import PaginationComponent from "../brands/Pagination";
import { approvaldurations } from "../assign-task/api";
import { getPendingapprovedTasks } from "../tasks/api";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabsCard(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const [value, setValue] = React.useState(0);
    const [searchTermcomplted, setSearchTermcomplted] = useState("");
    const [searchTermpending, setSearchTermpending] = useState("");
      const [searchTermRejected, setSearchTermRejected] = useState("");

  const [activeTaskData, setActiveTaskData] = useState([]);
  const [scheduleTaskData, setScheduleTaskData] = useState([]); // New state for scheduled tasks
  const [completedTaskData, setCompletedTaskData] = useState([]);
  const [rejectedTaskData, setRejectedTaskData] = useState([]);
  const [loading, setLoading] = useState(false); // Loading state
  const navigate = useNavigate();
  const perpagedata = 10;
  const [page, setPage] = useState(1);
  const [totalPages1, setTotalPages] = useState(0);
  const [Totalcount, setTotalcount] = useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [Totalcount1, setTotalcount1] = useState(0);
  const [activecoun, setactivecount] = useState(0);
  const [schedulecount, setschedulecount] = useState(0); // New state for schedule count
  const [pendingcount, setpendingcount] = useState(0);
  const [completedcount, setcompletedcount] = useState(0);
  const [rejectedcount, setrejectedcount] = useState(0);

   const [debouncedSearchPending, setDebouncedSearchPending] = useState(searchTermpending);
  const [debouncedSearchRejected, setDebouncedSearchRejected] = useState(searchTermRejected);

    const [searchTermtasks, setSearchTermactivetasks] = useState("");
      const [searchTermschduled, setSearchTermschduled] = useState("");

    const [sortOption, setSortOption] = useState<"highest" | "lowest" | null>(null);

   const [debouncedSearchactivetasks, setDebouncedSearchactivetasks] = useState(searchTermtasks);
  const [debouncedSearchsheduled, setDebouncedSearchschduled] = useState(searchTermschduled);
 const [sortOptionactivetask, setSortOptionactivetask] = useState<"highest" | "lowest" | null>(null);

  useEffect(() => {
  const handler = setTimeout(() => setDebouncedSearchactivetasks(searchTermtasks), 500);
  return () => clearTimeout(handler);
}, [searchTermtasks]);

useEffect(() => {
  const handler = setTimeout(() => setDebouncedSearchschduled(searchTermschduled), 500);
  return () => clearTimeout(handler);
}, [searchTermschduled]);


  const notaskData = [
    {
      id: 1,
      src: notask,
      title: "Currently, there are no tasks available.",
    },
  ];
  console.log(value, "valueddddddssssssssss");

  const { task_id, end_date } = useParams();
  const token = getToken();

  console.log(task_id, "task_idtask_id", end_date, "end_dateend_date");

  useEffect(() => {
    const fetchApprovalDurations = async () => {
      if (task_id && end_date) {
        try {
          const tt = await approvaldurations({ task_id, end_date }, token);
          console.log(tt);
        } catch (error) {
          console.error('Error fetching approval durations:', error);
        }
      }
    };

    fetchApprovalDurations();
  }, [task_id, end_date, token]);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const suffix =
      day % 10 === 1 && day !== 11
        ? "st"
        : day % 10 === 2 && day !== 12
        ? "nd"
        : day % 10 === 3 && day !== 13
        ? "rd"
        : "th";
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${day}${suffix} ${month} ${year}, ${hours}:${minutes}`;
  };
console.log(value, "444444444444444444")
  useEffect(() => {
    if (value === 1) {
      const fetchActiveTasksData = async () => {
        const token = getToken();
        try {
          setLoading(true);
          const response = await Activetasktab(token, page, 10,"",debouncedSearchactivetasks,sortOptionactivetask || '');
          const alldata = response.data.data.paginatedResults.map(
            (item: {
              task_status: any;
              created_at: any;
              points: any;
              actual_end_date: any;
              days_extentions: any;
              applied_filters: any;
              remaining_days: any;
              end_date: any;
              total_accounts: any;
              task_id: any;
              id: any;
              status: any;
              is_published: any;
              task_type: any;
              task_name: any;
              totalusers: any;
              assignedDate: any;
              assignedTime: any;
              endDate: any;
              endTime: any;
              remainingDaysLeft: any;
            }) => {
              return {
                id: item.id,
                task_id: item.task_id,
                taskTitle: item.task_type,
                title: item.task_name,
                totalUsers: item.total_accounts,
                assignedDate: formatDate(item.assignedDate),
                endDate: formatDate(item.end_date),
                tag: item.remaining_days,
                status: item.status,
                task_status: item.task_status,
                applied_filters: item.applied_filters,
                days_extenstions: item.days_extentions,
                actual_end_date: item.actual_end_date,
                points: item.points,
                created_at: formatDate(item.created_at),
              };
            }
          );

          setTimeout(() => {
            setActiveTaskData(alldata);
            setTotalcount(response.data.data.total_users);
            setactivecount(response.data.data.total_users);
            setLoading(false);
          }, 2000);
        } catch (error) {
          console.error("Error fetching active tasks:", error);
          setLoading(false);
        }
      };

      fetchActiveTasksData();
    }
  }, [value, page,debouncedSearchactivetasks,sortOptionactivetask]);

  useEffect(() => {
    if (value === 2) {
      const fetchScheduleTasksData = async () => {
        const token = getToken();
        try {
          setLoading(true);
          const response = await Activetasktab(token, page, 10,"scheduled",debouncedSearchsheduled,sortOptionactivetask || ''); // Removed "scheduled" parameter to match expected arguments
          const alldata = response.data.data.paginatedResults.map(
            (item: {
              task_status: any;
              created_at: any;
              points: any;
              actual_end_date: any;
              days_extentions: any;
              applied_filters: any;
              remaining_days: any;
              end_date: any;
              total_accounts: any;
              task_id: any;
              id: any;
              status: any;
              is_published: any;
              task_type: any;
              task_name: any;
              totalusers: any;
              assignedDate: any;
              assignedTime: any;
              endDate: any;
              endTime: any;
              remainingDaysLeft: any;
            }) => {
              return {
                id: item.id,
                task_id: item.task_id,
                taskTitle: item.task_type,
                title: item.task_name,
                totalUsers: item.total_accounts,
                assignedDate: formatDate(item.assignedDate),
                endDate: formatDate(item.end_date),
                tag: item.remaining_days,
                status: item.status,
                task_status: item.task_status,
                applied_filters: item.applied_filters,
                days_extenstions: item.days_extentions,
                actual_end_date: item.actual_end_date,
                points: item.points,
                created_at: formatDate(item.created_at),
              };
            }
          );

          setTimeout(() => {
            setScheduleTaskData(alldata);
            setTotalcount(response.data.data.total_users);
            setschedulecount(response.data.data.total_users);
            setLoading(false);
          }, 2000);
        } catch (error) {
          console.error("Error fetching scheduled tasks:", error);
          setLoading(false);
        }
      };

      fetchScheduleTasksData();
    }
  }, [value, page,debouncedSearchsheduled,sortOptionactivetask]);

  // useEffect(() => {
  //   if (value === 4) {
  //     const fetchCompletedTasksData = async () => {
  //       const token = getToken();
  //       try {
  //         setLoading(true);
  //         const response = await getPendingapprovedTasks(token, page, 10, "rejected");
  //         const alldata = response.data.data.paginatedResults.map(
  //           (item: {
  //             task_status: any;
  //             created_at: any;
  //             points: any;
  //             approved_count: any;
  //             actual_end_date: any;
  //             days_extentions: any;
  //             applied_filters: any;
  //             remaining_days: any;
  //             end_date: any;
  //             total_accounts: any;
  //             task_id: any;
  //             id: any;
  //             status: any;
  //             is_published: any;
  //             task_type: any;
  //             task_name: any;
  //             totalusers: any;
  //             assignedDate: any;
  //             assignedTime: any;
  //             endDate: any;
  //             endTime: any;
  //             remainingDaysLeft: any;
  //           }) => {
  //             return {
  //               id: item.id,
  //               task_id: item.task_id,
  //               taskTitle: item.task_type,
  //               title: item.task_name,
  //               points: item.points,
  //               created_at: formatDate(item.created_at),
  //               totalUsers: item.total_accounts,
  //               assignedDate: formatDate(item.assignedDate),
  //               endDate: formatDate(item.end_date),
  //               tag: item.remaining_days,
  //               status: item.task_status,
  //               applied_filters: item.applied_filters,
  //               days_extenstions: item.days_extentions,
  //               actual_end_date: item.actual_end_date,
  //               approvedCount: item.total_accounts,
  //             };
  //           }
  //         );

  //         setTimeout(() => {
  //           setCompletedTaskData(alldata);
  //           setTotalcount(response.data.data.total_users);
  //           setcompletedcount(response.data.data.total_users);
  //           setLoading(false);
  //         }, 2000);
  //       } catch (error) {
  //         console.error("Error fetching completed tasks:", error);
  //         setLoading(false);
  //       }
  //     };

  //     fetchCompletedTasksData();
  //   }
  // }, [value, page]);
useEffect(() => {
  if (value !== 4) return; // Exit early if tab is not 4

  const fetchRejectedTasksData = async () => {
    const token = getToken();
    try {
      setLoading(true);
      const response = await getPendingapprovedTasks(token, page, 10, "rejected",debouncedSearchRejected,sortOption?sortOption:'');

      const alldata = response.data.data.paginatedResults.map((item: any) => ({
        id: item.id,
        task_id: item.task_id,
        taskTitle: item.task_type,
        title: item.task_name,
        points: item.points,
        created_at: formatDate(item.created_at),
        totalUsers: item.total_accounts,
        assignedDate: formatDate(item.assignedDate),
        endDate: formatDate(item.end_date),
        tag: item.remaining_days,
        status: item.task_status,
        applied_filters: item.applied_filters,
        days_extenstions: item.days_extentions,
        actual_end_date: item.actual_end_date,
        approvedCount: item.total_accounts,
      }));

      setCompletedTaskData(alldata);
      setTotalcount(response.data.data.total_users);
      setrejectedcount(response.data.data.total_users)
      // setcompletedcount(response.data.data.total_users);
    } catch (error) {
      console.error("Error fetching rejected tasks:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchRejectedTasksData();
}, [value, page,debouncedSearchRejected,sortOption]);
const [debouncedSearchcomplted, setDebouncedSearchcomplted] = useState(searchTermcomplted);

useEffect(() => {
  const handler = setTimeout(() => setDebouncedSearchcomplted(searchTermpending), 500);
  return () => clearTimeout(handler);
}, [searchTermcomplted]);
console.log(debouncedSearchcomplted, "debouncedSearchcomplteddebouncedSearchcomplted")
console.log(completedTaskData, "completedTaskDatasssssssss")
  useEffect(() => {
    if (value === 5) {
      const fetchCompletedTasksData = async () => {
        const token = getToken();
        try {
          setLoading(true);
          const response = await getPendingapprovedTasks(token, page, 10, "completed",searchTermcomplted,sortOption?sortOption:'');
          const alldata = response.data.data.paginatedResults.map(
            (item: {
              task_status: any;
              created_at: any;
              points: any;
              approved_count: any;
              actual_end_date: any;
              days_extentions: any;
              applied_filters: any;
              remaining_days: any;
              end_date: any;
              total_accounts: any;
              task_id: any;
              id: any;
              status: any;
              is_published: any;
              task_type: any;
              task_name: any;
              totalusers: any;
              assignedDate: any;
              assignedTime: any;
              endDate: any;
              endTime: any;
              remainingDaysLeft: any;
            }) => {
              return {
                id: item.id,
                task_id: item.task_id,
                taskTitle: item.task_type,
                title: item.task_name,
                points: item.points,
                created_at: formatDate(item.created_at),
                totalUsers: item.total_accounts,
                assignedDate: formatDate(item.assignedDate),
                endDate: formatDate(item.end_date),
                tag: item.remaining_days,
                status: item.task_status,
                applied_filters: item.applied_filters,
                days_extenstions: item.days_extentions,
                actual_end_date: item.actual_end_date,
                approvedCount: item.total_accounts,
              };
            }
          );

          setTimeout(() => {
            setCompletedTaskData(alldata);
            setTotalcount(response.data.data.total_users);
            setcompletedcount(response.data.data.total_users);
            setLoading(false);
          }, 2000);
        } catch (error) {
          console.error("Error fetching completed tasks:", error);
          setLoading(false);
        }
      };

      fetchCompletedTasksData();
    }
  }, [value, page,searchTermcomplted,sortOption]);



  useEffect(() => {
    if (value === 3) {
      const fetchRejectedTasksData = async () => {
        const token = getToken();
        try {
          setLoading(true);
          const response = await getPendingapprovedTasks(token, page, 10, "pending",debouncedSearchPending,sortOption?sortOption:'');
          const alldata = response.data.data.paginatedResults.map(
            (item: {
              task_status: any;
              created_at: any;
              points: any;
              approved_count: any;
              actual_end_date: any;
              days_extentions: any;
              applied_filters: any;
              remaining_days: any;
              end_date: any;
              total_accounts: any;
              task_id: any;
              id: any;
              status: any;
              is_published: any;
              task_type: any;
              task_name: any;
              totalusers: any;
              assignedDate: any;
              assignedTime: any;
              endDate: any;
              endTime: any;
              remainingDaysLeft: any;
            }) => {
              return {
                id: item.id,
                task_id: item.task_id,
                taskTitle: item.task_type,
                title: item.task_name,
                points: item.points,
                created_at: formatDate(item.created_at),
                totalUsers: item.total_accounts,
                assignedDate: formatDate(item.assignedDate),
                endDate: formatDate(item.end_date),
                tag: item.remaining_days,
                status: item.task_status,
                applied_filters: item.applied_filters,
                days_extenstions: item.days_extentions,
                actual_end_date: item.actual_end_date,
                approvedCount: item.total_accounts,
              };
            }
          );

          setTimeout(() => {
            setRejectedTaskData(alldata);
            setTotalcount(response.data.data.total_users);
            // setrejectedcount(response.data.data.total_users);
            setLoading(false);
          }, 2000);
        } catch (error) {
          console.error("Error fetching rejected tasks:", error);
          setLoading(false);
        }
      };

      fetchRejectedTasksData();
    }
  }, [value, page,debouncedSearchPending,sortOption]);

  const totalPages12 = Math.ceil(Totalcount / perpagedata);
  console.log(value, "valuessssssssssssssss");
  console.log(loading, "loading4444445555");
  console.log(activeTaskData, "activeTaskData77888", scheduleTaskData, completedTaskData, rejectedTaskData);
  console.log(Totalcount1, "Totalcount1Totalcount1sssssssssssss", activecoun, "activecounactivecounactivecoun");
console.log(completedcount, "completedcountcompletedcounteee")
  return (
    <>
      <Box>
        <Box sx={{ padding: "28px 32px 0", background: "#FFF" }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontSize: "24px",
                fontWeight: "600",
                color: "#000",
                margin: "0px 0 20px",
              }}
            >
              Task Board
            </Typography>
            <Button
              onClick={() => {
                navigate("/manage-task/create-task");
                setTimeout(() => {
                  window.location.reload();
                }, 100);
              }}
              sx={{
                borderRadius: "8px",
                padding: "14px 16px",
                color: "#FFF",
                textDecoration: "none",
                background: "rgba(200, 23, 47, 1)",
                textAlign: "center",
                fontSize: "14px",
                fontWeight: "500",
                textTransform: "none",
              }}
            >
              <img style={{ marginRight: "8px" }} src={Plus} alt="Plus" />{" "}
              Create Tasks
            </Button>
          </Box>

          <Box sx={{ borderColor: "divider" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              sx={{
                ".MuiTabs-indicator": {
                  backgroundColor: "rgba(200, 23, 47, 1)",
                  height: "3px",
                },
              }}
            >
              <Tab
                label={`List of Tasks (${Totalcount1})`}
                {...a11yProps(0)}
                sx={{
                  "&.MuiButtonBase-root": {
                    color: "rgba(73, 74, 75, 1)",
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "17px",
                    padding: "0px",
                    marginRight: "24px",
                    textTransform: "capitalize",
                  },
                  "&.Mui-selected": { color: "#000", fontWeight: "600" },
                }}
              />
              <Tab
                label={`Active Task(${activecoun})`}
                {...a11yProps(1)}
                sx={{
                  "&.MuiButtonBase-root": {
                    color: "rgba(73, 74, 75, 1)",
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "17px",
                    padding: "0px",
                    marginRight: "24px",
                    textTransform: "capitalize",
                  },
                  "&.Mui-selected": { color: "#000", fontWeight: "600" },
                }}
              />
              <Tab
                label={`scheduled Task(${schedulecount})`}
                {...a11yProps(2)}
                sx={{
                  "&.MuiButtonBase-root": {
                    color: "rgba(73, 74, 75, 1)",
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "17px",
                    padding: "0px",
                    marginRight: "24px",
                    textTransform: "capitalize",
                  },
                  "&.Mui-selected": { color: "#000", fontWeight: "600" },
                }}
              />
              <Tab
                label={`Pending Task (${pendingcount})`}
                {...a11yProps(3)}
                sx={{
                  "&.MuiButtonBase-root": {
                    color: "rgba(73, 74, 75, 1)",
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "17px",
                    padding: "0px",
                    marginRight: "24px",
                    textTransform: "capitalize",
                  },
                  "&.Mui-selected": { color: "#000", fontWeight: "600" },
                }}
              />
              <Tab
                label={`Rejected Task (${rejectedcount})`}
                {...a11yProps(4)}
                sx={{
                  "&.MuiButtonBase-root": {
                    color: "rgba(73, 74, 75, 1)",
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "17px",
                    padding: "0px",
                    marginRight: "24px",
                    textTransform: "capitalize",
                  },
                  "&.Mui-selected": { color: "#000", fontWeight: "600" },
                }}
              />
              <Tab
                label={`Completed Tasks (${completedcount})`}
                {...a11yProps(5)}
                sx={{
                  "&.MuiButtonBase-root": {
                    color: "rgba(73, 74, 75, 1)",
                    fontSize: "16px",
                    fontWeight: "500",
                    lineHeight: "17px",
                    padding: "0px",
                    marginRight: "24px",
                    textTransform: "capitalize",
                  },
                  "&.Mui-selected": { color: "#000", fontWeight: "600" },
                }}
              />
            </Tabs>
          </Box>
        </Box>

        <TabsCard value={value} index={0}>
          {value === 0 && (
            <Productcard
            schedulecount={schedulecount} setschedulecount={setschedulecount} rejectedcount={rejectedcount} setrejectedcount={setrejectedcount}
              Totalcount={Totalcount1}
              setTotalcount={setTotalcount1}
              activecoun={activecoun}
              setactivecount={setactivecount}
              pendingcount={pendingcount}
              setpendingcount={setpendingcount}
              completedcount={completedcount}
              setcompletedcount={setcompletedcount}
            />
          )}
        </TabsCard>

        <TabsCard value={value} index={1}>
          <ActiveTask
            loading={loading}
           sortOptionactivetask={sortOptionactivetask} 
        setSortOptionactivetask={setSortOptionactivetask}  activeTaskData={activeTaskData} title={undefined} searchTermtasks={searchTermtasks}
  setSearchTermactivetasks={setSearchTermactivetasks}
  searchTermschduled={searchTermschduled}
  value={value}
  setSearchTermschduled={setSearchTermschduled}
  debouncedSearchactivetasks={debouncedSearchactivetasks}
  setDebouncedSearchactivetasks={setDebouncedSearchactivetasks}
  debouncedSearchsheduled={debouncedSearchsheduled}
  setDebouncedSearchschduled={setDebouncedSearchschduled}
          />
        </TabsCard>

        <TabsCard value={value} index={2}>
          <ActiveTask
            loading={loading}
           sortOptionactivetask={sortOptionactivetask} 
        setSortOptionactivetask={setSortOptionactivetask}   value={value} activeTaskData={scheduleTaskData} title={undefined} searchTermtasks={searchTermtasks}
  setSearchTermactivetasks={setSearchTermactivetasks}
  searchTermschduled={searchTermschduled}
  setSearchTermschduled={setSearchTermschduled}
  debouncedSearchactivetasks={debouncedSearchactivetasks}
  setDebouncedSearchactivetasks={setDebouncedSearchactivetasks}
  debouncedSearchsheduled={debouncedSearchsheduled}
  setDebouncedSearchschduled={setDebouncedSearchschduled}
          />
        </TabsCard>
        <TabsCard value={value} index={3}>
          {value === 3 && (
            <PendingTasks
            sortOption={sortOption} 
        setSortOption={setSortOption} 
            debouncedSearchRejected={debouncedSearchRejected} setDebouncedSearchRejected={setDebouncedSearchRejected}
            debouncedSearchPending={debouncedSearchPending} setDebouncedSearchPending={setDebouncedSearchPending}
            searchTermRejected={searchTermRejected}
      setSearchTermRejected={setSearchTermRejected}
             setSearchTermpending={setSearchTermpending}
           searchTermpending={searchTermpending}
              Totalcount={pendingcount}
              setTotalcount={setpendingcount}
              type={""}
                value={3}
            />
          )}
        </TabsCard>

        <TabsCard value={value} index={4}>
  {value === 4 && (
    <PendingTasks 
      sortOption={sortOption}
      setSortOption={setSortOption}
      debouncedSearchRejected={debouncedSearchRejected}
      setDebouncedSearchRejected={setDebouncedSearchRejected}
      debouncedSearchPending={debouncedSearchPending}
      setDebouncedSearchPending={setDebouncedSearchPending}
      searchTermRejected={searchTermRejected}
      setSearchTermRejected={setSearchTermRejected}
      setSearchTermpending={setSearchTermpending}
      searchTermpending={searchTermpending}
      Totalcount={rejectedcount}
      setTotalcount={setrejectedcount}
      type="rejected"
      value={4}
    />
  )}
</TabsCard>


       <TabsCard value={value} index={5}>
  {value === 5 && (
    <CompletedTask
    loading={loading}
      searchTermcomplted={searchTermcomplted}
      setSearchTermcomplted={setSearchTermcomplted}
      activeTaskData={completedTaskData}
      title=""
      sortOption={sortOption}
      setSortOption={setSortOption}
    />
  )}
</TabsCard>

        {(value === 1 || value === 2 || value === 4 || value === 5) && (
          <Box
            sx={{
              background: "#fff",
              borderBottom: "1px solid rgba(224, 224, 224, 1)",
              borderTop: "1px solid rgba(224, 224, 224, 1)",
              margin: "0px",
            }}
          >
            {(activeTaskData.length > 0 || scheduleTaskData.length > 0 || completedTaskData.length > 0 ) ? (
              <PaginationComponent
                page={page}
                limit={10}
                totalPages={totalPages12}
                setPage={setPage}
              />
            ) : null}
          </Box>
        )}
      </Box>
    </>
  );
}